// ** React Imports
import { useMemo } from "react";
import { useParams } from "react-router-dom";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Hooks
import useQuery from "hooks/useQuery";

// #####################################################

const useLocationFilterData = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors"]);

	const language = useSelector((state) => state.globalCommon.language);

	// ** Odczytanie parametrów z adresu URL
	const params = useParams();
	const {
		country: countryUrl,
		region: regionUrl,
		city: cityUrl,
	} = params || {};

	// ** Odczytanie parametrów 'search' z adresu URL
	const query = useQuery();
	const { distance: distanceUrl } = query || {};

	const {
		country: countryName,
		countryId,
		city: cityLocation,
		region: regionLocation,
	} = useSelector((state) => state.mainPageUsers.location);

	const countryLocation = countryId
		? t(`countries:${countryId}`)
		: countryName || null;

	const locationText = useMemo(() => {
		if (cityUrl && cityLocation) {
			return `${cityLocation ? `${cityLocation}, ` : ""}${
				regionLocation ? `${regionLocation}, ` : ""
			}${countryLocation ? `${countryLocation}` : ""}${
				Number(distanceUrl) ? `, +${distanceUrl} km` : ""
			}`;
		} else if (regionUrl && regionLocation) {
			return `${regionLocation ? `${regionLocation}, ` : ""}${
				countryLocation ? `${countryLocation}` : ""
			}`;
		} else if (countryUrl && countryLocation) {
			return `${countryLocation ? `${countryLocation}` : ""}`;
		}
		return "";
	}, [
		cityUrl,
		regionUrl,
		countryUrl,
		distanceUrl,
		cityLocation,
		regionLocation,
		countryLocation,
		language,
	]);

	// ** Filtr - Lokalizacja
	const locationFilterData = useMemo(() => {
		return locationText
			? {
					label: t("filtersAndSelectors:locationLabel"),
					selected: locationText,
			  }
			: null;
	}, [locationText, language]);

	// #####################################################

	return locationFilterData;
};

// #####################################################

export default useLocationFilterData;

// #####################################################
